<mat-select
	[placeholder]="'00:00'"
	[(ngModel)]="this.passedInTime"
	(ngModelChange)="onSelection($event)"
	[disabled]="this.disabled"
	data-automation-id="military-time-picker"
	[class.time-border-invalid]="!isCurrentTimeValid"
>
	<mat-select-trigger>
		<span class="time-display" [class.invalid-time]="!isCurrentTimeValid"
			>{{ (passedInTime || '00:00').split(':')[0] }}<span class="time-separator">:</span
			>{{ (passedInTime || '00:00').split(':')[1] }}</span
		>
	</mat-select-trigger>
	@for (time of this.timeValues; track time.value) {
		<mat-option
			[value]="time.value"
			[disabled]="
				(!!endTimeMustBeAfter && time.value < endTimeMustBeAfter) ||
				(!!endTimeMustBeBefore && time.value > endTimeMustBeBefore)
			"
			[class.invalid-time]="!isTimeValid(time.value)"
			[attr.data-automation-id]="'time-value-' + time"
		>
			{{ time.valueName }}
		</mat-option>
	}
</mat-select>
